import { molsonUseTheme } from '@theme/customMuiExports'
export const useQuoteMarginColors = (type: 'default' | 'success' | 'error') => {
  const theme = molsonUseTheme()

  const colors = {
    default: theme.palette.secondary[600],
    error: theme.palette.primary.error,
    success: theme.palette.primary.successContentSecondary
  }
  const borderColors = {
    default: theme.palette.primary.successBorderSecondary,
    error: theme.palette.primary.errorBorderSecondary,
    success: theme.palette.primary.successBorderSecondary
  }
  const bgColors = {
    default: theme.palette.secondary.surfaceSuccess,
    error: theme.palette.secondary.lavenderBlush,
    success: theme.palette.secondary.surfaceSuccess
  }

  const textColor = colors[type]
  const borderColor = borderColors[type]
  const bgColor = bgColors[type]

  return {
    textColor,
    borderColor,
    bgColor,
    colors
  }
}
